<button class="ui icon button refresh-button" (click)="onClick()">
  <i class="refresh icon"></i>
</button>
